// ========== 任务引擎 ==========
import { QUESTS } from '../data/quest-data.js';

// 初始化任务系统
export function initQuests() {
  if(!window.S) return;
  if(!window.S._quests) {
    window.S._quests = {};
    window.S._questLog = []; // 已完成任务
    window.S._questDailyDate = ''; // 上次每日重置日期
  }
  checkDailyReset();
}

// 获取所有可用任务（未完成、满足前置条件）
export function getAvailableQuests() {
  initQuests();
  checkDailyReset();
  const all = Object.values(QUESTS);
  const available = [];
  
  all.forEach(q => {
    if(window.S._questLog.includes(q.id)) return; // 已完成
    if(q.reqLv && window.S.lv < q.reqLv) return; // 等级不足
    if(q.reqQuest && !window.S._questLog.includes(q.reqQuest)) return; // 前置未完成
    if(q.daily) {
      // 每日任务始终可用（但每天重置进度）
    }
    available.push(q);
  });
  
  return available;
}

// 获取活跃任务（有进度的）
export function getActiveQuests() {
  return getAvailableQuests().filter(q => {
    const p = window.S._quests[q.id];
    return p && p.progress > 0;
  });
}

// 每日重置检查
export function checkDailyReset() {
  const today = new Date().toISOString().slice(0,10);
  if(window.S._questDailyDate !== today) {
    // 重置每日任务进度
    Object.keys(QUESTS).forEach(qid => {
      if(QUESTS[qid].daily) {
        window.S._quests[qid] = { progress:0 };
      }
    });
    window.S._questDailyDate = today;
    window.save && window.save();
  }
}

// 进度追踪
export function trackQuest(type, target, amount = 1) {
  initQuests();
  checkDailyReset();
  const avail = getAvailableQuests();
  let completed = [];
  
  avail.forEach(q => {
    if(q.objective.type !== type) return;
    
    const objTarget = q.objective.target;
    // 检查目标匹配
    if(objTarget !== 'any' && objTarget !== target && objTarget !== String(target)) return;
    
    if(!window.S._quests[q.id]) window.S._quests[q.id] = { progress:0 };
    const p = window.S._quests[q.id];
    p.progress = Math.min(q.objective.count, (p.progress||0) + amount);
    
    if(p.progress >= q.objective.count && !p.completed) {
      p.completed = true;
      completed.push(q);
    }
  });
  
  // 通知已完成任务
  completed.forEach(q => {
    completeQuest(q);
  });
  
  return completed;
}

// 完成任务
export function completeQuest(q) {
  if(window.S._questLog.includes(q.id)) return;
  window.S._questLog.push(q.id);
  
  // 发放奖励
  if(q.rewards.gold) window.S.gold += q.rewards.gold;
  if(q.rewards.exp) { window.S.exp += q.rewards.exp; window.checkLevelUp && window.checkLevelUp(); }
  if(q.rewards.items) {
    q.rewards.items.forEach(it => {
      for(let i=0;i<(it.qty||1);i++) {
        if(it.id === 'chaos_crystal') {
          if(!window.S.chaosCrystals) window.S.chaosCrystals = 0;
          window.S.chaosCrystals += 1;
        } else {
          if(!window.S.inventory) window.S.inventory = [];
          window.S.inventory.push({ id:it.id, type:'consumable' });
        }
      }
    });
  }
  if(q.rewards.statBonus) {
    if(q.rewards.statBonus.atk) window.S.atk = (window.S.atk||0) + q.rewards.statBonus.atk;
    if(q.rewards.statBonus.def) window.S.def = (window.S.def||0) + q.rewards.statBonus.def;
  }
  
  // 如果有后续任务，解锁之
  if(q.nextQuest) {
    const next = QUESTS[q.nextQuest];
    if(next) {
      if(!window.S._quests[q.nextQuest]) window.S._quests[q.nextQuest] = { progress:0 };
    }
  }
  
  window.save && window.save();
  
  // 显示完成通知
  setTimeout(() => {
    if(window.toast) {
      window.toast(`📜 任务完成：${q.icon} ${q.name}！`, 3500);
    }
    // 奖励Toasts
    setTimeout(() => {
      const r = q.rewards;
      let msg = '🎁 获得：';
      if(r.gold) msg += ` ${r.gold}G`;
      if(r.exp) msg += ` +${r.exp}EXP`;
      if(r.statBonus) msg += ` 属性提升`;
      if(r.items) msg += ` 道具x${r.items.reduce((s,i)=>s+(i.qty||1),0)}`;
      if(window.toast) window.toast(msg, 3000);
    }, 200);
  }, 500);
}

// 获取任务进度描述
export function getQuestProgress(q) {
  const p = window.S._quests && window.S._quests[q.id];
  const current = p ? (p.progress||0) : 0;
  const total = q.objective.count;
  const pct = Math.min(100, Math.floor(current/total*100));
  return { current, total, pct, completed: p && p.completed };
}
